<template>
  <img :idProfile="profile.id" :connected="profile.connected" :alt="alt" :src="src" class="connected" />
</template>

<script>
export default {
  name: "ConnectedIcon",
  props: ["profile"],
  computed: {
    offline() {
      return this.profile.connected === false || this.profile.status == 1;
    },

    alt: function() {
      if (this.offline) {
        return "deconnecté";
      } else {
        return "connecté";
      }
    },

    src: function() {
      if (this.offline) {
        return "/assets/icons_pink/disconnected.png";
      } else {
        return "/assets/icons_pink/connected.png";
      }
    }
  }
};
</script>

<style scoped></style>
